import BASEURLGESTTOR from '../api/gesttor'
import { paramsDre } from '../../interfaces/relatorios'

export function dre (params: paramsDre) {
    return BASEURLGESTTOR.get(`/relatorios/dre?ano=${params.ano}&idCentro=${params.idCentro}`)
}

export function dfc (params: paramsDre) {
    return BASEURLGESTTOR.get(`/relatorios/dfc?ano=${params.ano}&idCentro=${params.idCentro}`)
}